import React from "react";
import { Link } from "react-router-dom";
import "./ProjectCard.css";

const ProjectCard = ({ project }) => {
  return (
    <div className="project-card">

      <img src={project.image} alt={project.title} />

      <h3>{project.title}</h3>

      <p>{project.description}</p>

      <div className="buttons">

        <a
          href={project.live}
          target="_blank"
          rel="noreferrer"
        >
          Live Demo
        </a>

        <a
          href={project.github}
          target="_blank"
          rel="noreferrer"
        >
          GitHub
        </a>

        <Link to={`/projects/${project.id}`}>
          View Details
        </Link>

      </div>

    </div>
  );
};

export default ProjectCard;